var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "v-scale-transition",
        { attrs: { "hide-on-leave": "" } },
        [_c("router-view")],
        1
      ),
      _c("create-feedback-modal", {
        attrs: { smallScreen: false },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function(ref) {
              var on = ref.on
              return [
                !_vm.IS_EMPLOYEE
                  ? _c(
                      "v-btn",
                      _vm._g(
                        {
                          attrs: {
                            color: "#BE2585",
                            dark: "",
                            fixed: "",
                            bottom: "",
                            right: "",
                            fab: "",
                            large: ""
                          }
                        },
                        on
                      ),
                      [
                        _c("feedback-icon", {
                          staticClass: "mr-2",
                          attrs: {
                            width: "35",
                            height: "35",
                            iconColor: "white"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm.showLoader ? _c("dayco-loader") : _vm._e(),
      _c("portal-message")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }